import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';
const color = 'white';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    container: {
      scrollSnapType: 'y mandatory',
    },
    containerChild: {
      scrollSnapAlign: 'start',
    },
    heading: {
      fontSize: { base: '28px', lg: '36px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontWeight: 500,
      lineHeight: { base: '35px', lg: '40px' },
      color: color,
      letterSpacing: '-2px',
    },
    subHeading: {
      fontSize: { base: '28px', lg: '36px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontWeight: 500,
      lineHeight: { base: '28px', lg: '40px' },
      color: 'rgba(240, 30, 31, 1)',
      letterSpacing: '-2px',
    },
    description: {
      fontSize: { base: '16px', lg: '18px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: 400,
      lineHeight: { base: '19.2px', lg: '24px' },
      color: 'rgb(255 255 255 / 70%)',
      letterSpacing: '-1px',
      paddingTop: '1rem',
    },
    title: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: '500',
      fontSize: { base: '32px', md: '32px' },
      lineHeight: '30px',
      letterSpacing: '-1px',
      color: color,
    },
    mainHeading: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontWeight: '500',
      fontSize: { base: '64px', md: '72px' },
      fontStyle: 'italic',
      lineHeight: '70px',
      letterSpacing: '0%',
      color: '#F01E1F',
    },
    bottomDesc: {
      fontSize: { base: '16px', lg: '24px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: 400,
      lineHeight: { base: '26px', lg: '35px' },
      color: '#fff',
      letterSpacing: '-1px',
      paddingTop: '1rem',
      textAlign: { base: 'left', md: 'center' },
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const WhatSetsMomApartSt = {
  en: commonLangStyle({ lang: 'en' }),
  bn: commonLangStyle({ lang: 'bn' }),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ 
    lang: 'te',
    heading: {
      ...commonLangStyle({ lang: 'te' }).heading,
      lineHeight: { base: '38px', lg: '44px' },
    },
    mainHeading: {
      ...commonLangStyle({ lang: 'te' }).mainHeading,
      wordBreak: 'break-all',
      lineHeight: { base: '92px', lg: '101px' },
    },
   }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({ lang: 'ru' }),
  ta: commonLangStyle({
    lang: 'ta',
    heading: {
      ...commonLangStyle({ lang: 'ta' }).heading,
      wordBreak: 'break-all',
    },
    subHeading: {
      ...commonLangStyle({ lang: 'ta' }).subHeading,
      wordBreak: 'break-all',
    },
    description: {
      ...commonLangStyle({ lang: 'ta' }).description,
      wordBreak: 'break-all',
    },
    title: {
      ...commonLangStyle({ lang: 'ta' }).title,
      wordBreak: 'break-all',
    },
    mainHeading: {
      ...commonLangStyle({ lang: 'ta' }).mainHeading,
      wordBreak: 'break-all',
    },
    bottomDesc: {
      ...commonLangStyle({ lang: 'ta' }).bottomDesc,
      wordBreak: 'break-all',
    },
  }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default WhatSetsMomApartSt;
